import logo_dark from '../assets/images/somnium/somnium-logo-dark.png';
import logo_light from '../assets/images/somnium/somnium-logo-white.png';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { useLocalizedData } from '../hooks/useTranslatedContent';

const langMap = {
    'ENGLISH': 'en',
    'РУССКИЙ': 'ru',
    'ՀԱՅԵՐԵՆ': 'hy'
};

const displayMap = {
    'en': 'ENGLISH',
    'ru': 'РУССКИЙ',
    'hy': 'ՀԱՅԵՐԵՆ'
};

export default function NavbarSmallLight({ navbarData }) {
    const [isOpen, setMenu] = useState(true);
    const [langDropdownOpen, setLangDropdownOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { getLocalized } = useLocalizedData(navbarData);

    const currentLang = displayMap[i18n.language] || 'ENGLISH';

    const changeLang = (displayLang) => {
        const newLangCode = langMap[displayLang];
        localStorage.setItem("selectedLanguage", newLangCode);
        i18n.changeLanguage(newLangCode);
        setLangDropdownOpen(false);

        const pathSegments = location.pathname.split('/');
        pathSegments[1] = newLangCode;
        const newPath = pathSegments.join('/');
        navigate(newPath);
    };

    useEffect(() => {
        window.addEventListener("scroll", windowScroll);
        return () => {
            window.removeEventListener("scroll", windowScroll);
        };
    }, []);

    function windowScroll() {
        const navbar = document.getElementById("navbar");
        const isScrolled = document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50;

        if (isScrolled) {
            navbar?.classList.add("is-sticky");
            setIsSticky(true);
        } else {
            navbar?.classList.remove("is-sticky");
            setIsSticky(false);
        }

        const mybutton = document.getElementById("back-to-top");
        if (mybutton != null) {
            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                mybutton.classList.add("flex");
                mybutton.classList.remove("hidden");
            } else {
                mybutton.classList.add("hidden");
                mybutton.classList.remove("flex");
            }
        }
    }

    const toggleMenu = () => {
        setMenu(!isOpen);
    };

    const navLinkClass = `nav-link ${isSticky ? 'text-black hover:text-black' : ''}`;

    const availableLangs = ['ՀԱՅԵՐԵՆ', 'РУССКИЙ', 'ENGLISH'];

    return (
        <nav className="navbar" id="navbar">
            <div className="container flex flex-wrap items-center justify-end">
                <a className="navbar-brand md:me-8" href={`/${i18n.language}`}>
                    <span className="inline-block dark:hidden">
                        <img src={logo_dark} className="l-dark" style={{ width: '150px', height: '95px' }} alt="" />
                        <img src={logo_light} className="l-light" style={{ width: '150px', height: '95px' }} alt="" />
                    </span>
                    <img src={logo_light} style={{ width: '150px', height: '95px' }} className="hidden dark:inline-block" alt="" />
                </a>

                <div className="nav-icons flex items-center lg_992:order-2 ms-auto lg:ms-4">
                    <button data-collapse="menu-collapse" type="button" onClick={toggleMenu}
                            className="collapse-btn inline-flex items-center ms-3 text-slate-950 dark:text-white lg_992:hidden"
                            aria-controls="menu-collapse" aria-expanded="false">
                        <span className="sr-only">Navigation Menu</span>
                        <i className="mdi mdi-menu text-[24px]"></i>
                    </button>
                </div>

                <div className={`${isOpen === true ? 'navigation lg_992:order-1 lg_992:flex hidden ms-auto' : 'navigation lg_992:order-1 lg_992:flex block ms-auto '}`} id="menu-collapse">
                    <ul className="navbar-nav nav-light" id="navbar-navlist">
                        <li className="nav-item">
                            <Link to={`/${i18n.language}`} className={navLinkClass}>{getLocalized('home')}</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/${i18n.language}/about`} className={navLinkClass}>{getLocalized('about')}</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/${i18n.language}/enterprises`} className={navLinkClass}>{getLocalized('enterprises')}</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/${i18n.language}/contact-us`} className={navLinkClass}>{getLocalized('contactUs')}</Link>
                        </li>

                        {/* Language Dropdown */}
                        <li className="nav-item relative">
                            <button
                                className={`nav-link flex items-center gap-1 focus:outline-none nav-item active:text-white ${isSticky ? 'text-black hover:text-black' : ''}`}
                                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
                            >
                                {currentLang}
                                {langDropdownOpen ? (
                                    <IoChevronUp className="text-lg" />
                                ) : (
                                    <IoChevronDown className="text-lg" />
                                )}
                            </button>

                            {langDropdownOpen && (
                                <ul className="absolute right-0 mt-2 w-44 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl z-50 animate-fade-in-down ring-1 ring-black/5 dark:ring-white/10 backdrop-blur-md">
                                    {availableLangs
                                        .filter(lang => lang !== currentLang)
                                        .map(lang => (
                                            <li key={lang}>
                                                <button
                                                    onClick={() => changeLang(lang)}
                                                    className="block w-full text-left px-5 py-3 text-sm font-semibold text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200 rounded-md hover:scale-[1.02]"
                                                >
                                                    {lang}
                                                </button>
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}